module.exports = __webpack_public_path__ + "readmeTemplates/connectedDevices.83e6045e3f83d4e1bf24848579a3f79d.md";